<div
  *ngIf="items$ | async as items"
  class="container"
>
  <ng-container *ngFor="let item of items; index as i">
    <div class="container__header">
      <div
        class="header"
        (click)="onItemClick(item.value)"
      >
        <div
          class="header__tick"
          [ngClass]="{
            header__tick_active: item.value === (value$ | async)
          }"
        ></div>
        <div class="header__label">
          <ng-container
            *ngTemplateOutlet="item.header.contentRef$ | async"
          ></ng-container>
        </div>
        <div
          *ngIf="item.imgSrc || item.imgSrc2"
          class="header__icons-wrap"
        >
          <img
            *ngIf="item.imgSrc"
            class="header__icons"
            [src]="item.imgSrc"
          />
          <img
            *ngIf="item.imgSrc2"
            class="header__icons konbini"
            [src]="item.imgSrc2"
          />
        </div>
      </div>
    </div>
    <div
      *ngIf="item.value === (value$ | async)"
      class="container__content"
      [@slideY]
    >
      <ng-container
        *ngTemplateOutlet="item.content.contentRef$ | async"
      ></ng-container>
    </div>
  </ng-container>
</div>
